import { Sport } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';
import idFromObject from 'gql/idFromObject';
import { local as localStorage } from 'lib/storage';

export const useLocalStorageKey = (
  s: Sport,
  currentUserId: string | undefined
) => {
  if (!currentUserId) {
    return `cardswap_anonymous`; // doesn't matter
  }
  return `cardswap_${s}_${idFromObject(currentUserId)}`;
};

export const clearLocalStorageKey = (
  s: Sport,
  currentUserId: string | undefined
) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const key = useLocalStorageKey(s, currentUserId);
  localStorage.removeItem(key);
};

const useLocalStorageState = (sport: Sport) => {
  const { currentUser } = useCurrentUserContext();
  const key = useLocalStorageKey(sport, currentUser?.id);
  // we need to look at the actual local storage key
  // because `useLocalStorage` is not a central store.
  const get = () => {
    const rawState = localStorage.getItem(key);
    if (!rawState) return undefined;
    try {
      return JSON.parse(rawState);
    } catch (e: any) {
      return undefined;
    }
  };
  return { get };
};

export const useLocalStorageTradeId = (sport: Sport) => {
  const { get } = useLocalStorageState(sport);
  return { get: () => get()?.tradeId };
};
